<div [hidden]="hideInstructions" class="alert alert-info" role="alert">
  <p>Our data indicates that this may be a drug prescribed by one of your providers for one of your patients.</p>
  <p>
    Use the information below to determine if you have a matching encounter at a 340B-eligible location and the
    prescription in your EMR. By approving this match, you will approve all current and future fills for this unique
    prescription.
  </p>
</div>
